import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color } from 'theme';
import { StyledContainer } from '../shared/sectionChart/SectionChart.styled';
import { StyledHero } from '../shared/sectionHero/SectionHero.styled';

export const StyledSection = styled.div`
  ${StyledHero} {
    background-color: ${color('purple_100')};
  }

  ${StyledContainer} ${Heading2}::before {
    background-color: ${color('purple_500')};
  }
`;
